import { medicalPatient, officeAsset, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/retailExhibition/video/rtlsVideo.mp4';

export default {
  desc: 'NVR (Network Video Recorder) là một thiết bị có chức năng nhận và lưu trữ các luồng video kỹ thuật số được truyền từ camera IP hoặc camera mạng. Nó chủ yếu được sử dụng trong các hệ thống giám sát và an ninh. Thiết bị này được phân biệt với đầu ghi hình kỹ thuật số (DVR) hiện có và chủ yếu hoạt động với camera kỹ thuật số.',
  keywords: 'NVR, Camera, Camera an ninh, Theodoivitri, Theo dõi vị trí',
  ogSite: 'NVR là gì?',
  title: 'NVR là gì?',
  ogUrl: 'https://orbro.io/vi/blog/nvr',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmL4Stf6lklybaH3OesTetv_ifx8JMPoVd04awuiZ4-02dNTkyV_aHj1fMf2KnR4WC3V8BIU0tp4nnqyMrJ1H3wq2E2MR1v4SC2aV7X0uQuYIPhuSRRExRshekWS5QDY7QauCkENm0TmU7Nd5ybqI8YS9VYjU47WZpMCiPjMURQQed_nvkn0AhE2Yun2VlI0rqIh4wdfyfrV8KCYwxBiuTJu0JyormxuEVYxQX_zzHdRwQHQRmGDKitVvEFslYvVFcRU7zmk1H5su0Nbh0OH-2sr7PH92g1JPUqxCgUlBTxhpLdrL_E6UqQka9fnmGxwy-M42lPeCHvlJ3pjxezqOwNVArbkw4Gtzl8eeAr8IbZ4rZ9wTIRi05-bGw29_Cz-zxphiYy_phH52YKkFQP5NEH11pxn9SDr8Xgj6EZqd95NgevWxTMMi4O1A6iOydRW_EOn4lix025cQB5RehRr0gZlPIVwj_YEku0bG-va9JpG6rAPHUbj_AELcIbLToKJnyJ-DYE-gTASAaIamUNLzKNoXmIGa9phep5L_nIkwEHdA-qzT5dyrmhQDpc4d1ruaYFLHWV-bb-ETaORk4Sdr3Y-aqznGhdsafAvy0lGxYU_DMVM_emH2uyyVFq71xraelVNooi5Qoe-PsPuj8BnSOTSZeLGWmuglDlrgmTuEpFNqsVou185a6VQJO6s71py93y5OpnwMtj3FmATd_eeN9ZY43KUQ2iLDXw125g3abOP4HE4YnRCCsMjz3Vray4TP2_m_9QoRm8OuJBGF4A2CbGJ2M8oLmEQ1Mc3VpNZ9WwdYkGXpBY8yCLEuDwxqeKNMUTkJwbr4YNdpja17MLWg9XHFoVNlG64qk-VkBi4IFSFMDx4LaZD9XsGttmU9bBIIT2jJldP5PYCfTjffwwstwZ4VNG-3bxzqfsCZ3CGeihhAYm1knV-ullCOomsYIaweJwLK2MMRFkxlpRPuT0bbJnFWuCdMoydkNYf3JMh0Bi2kok0mrqpGDEqywp9sccVcp8wZkG1XRVZJPJjwSd2kbiJNR2DfwoneK2ivKwpqhT5kRrl9cpuclYrRgIqnlOuce-kuOj0dJMTozXERXeWUzhXWX4EFywOc-1IoTXFtxiPQL76CyCsHtYImgIoegeus-2_6ZQZtpmxvYL33d95jUw3J_yUPkWETDzHro5RGKOD5RDM41CMUEokOzoWbxmbO0MufhfRGY_PnM5W16XGqSZGRTwenay9yrEB3IPluMmrdpervFylEfCPYJyutGFQigW5iY-tvjM8JVOyzk3OqLzqq9LjnJAyhkCJZ2ZGtPKZPvMvOSlovrdc93ztDGD6dorfc1SWfaxDOi4kQduozkGE8GSEkHRte9hFjdoWMGblqD1Lu4ADPGwr2546UPK93UJbiCtj2SUaSVV8E5R1XD3cy4mKcZ27rsDh_s_os0RaZ8lEQfPHZMmphlOnC2S5AnuXnZqqQWPQJD9b2v8kYV9CS3vW8_Gr3zLg1jcDqGfeBbzTg3g3rtTUPi885LTBUpT_NK2a5Ux-HCwPu1da_Cen1_2-oto=w1984-h1208',
  ogType: 'website',
  date: '2024-01-12',
  tag1: '#NVR',
  tag2: '#Camera',
  tag3: '#Cameraanninh',
  tag4: '#Theodoivitri',
  text: [
    {
      head: 'NVR là gì?',
      subHead: '',
      desc: 'NVR (Network Video Recorder) là một thiết bị có chức năng nhận và lưu trữ các luồng video kỹ thuật số được truyền từ camera IP hoặc camera mạng. Nó chủ yếu được sử dụng trong các hệ thống giám sát và an ninh. Thiết bị này được phân biệt với đầu ghi hình kỹ thuật số (DVR) hiện có và chủ yếu hoạt động với camera kỹ thuật số.\nNVR được thiết kế để quản lý và truy cập video từ nhiều vị trí khác nhau thông qua mạng. Điều này đặc biệt hữu ích cho các cơ sở quy mô lớn hoặc khi cần giám sát trên nhiều khu vực, đồng thời hỗ trợ độ phân giải cao hơn và các tính năng nâng cao, mang lại hiệu suất vượt trội. Về mặt chức năng, NVR đồng thời tiếp nhận luồng video từ nhiều camera và lưu trữ an toàn. Video đã lưu có thể được sử dụng sau này để tìm kiếm, phát lại hoặc phân tích. Ngoài ra, nhiều hệ thống NVR còn cung cấp các tính năng nâng cao như thông báo qua email, giám sát từ xa hoặc phát hiện chuyển động, cho phép giám sát hiệu quả.\nVới những đặc điểm này, NVR được sử dụng rộng rãi trong môi trường yêu cầu bảo mật cao và trở thành một trong những thành phần cốt lõi của hệ thống giám sát hiện đại dựa trên mạng.',
      dot: '',
    },
    {
      head: 'Các tính năng của NVR',
      subHead: 'Quản lý Camera',
      desc: ' • Hỗ trợ và quản lý hiệu quả nhiều camera kỹ thuật số.\n • Cho phép cấu hình linh hoạt thông qua việc nhóm camera và cài đặt riêng lẻ.\n',
      dot: '',
    },
    {
      head: '',
      subHead: 'Độ phân giải cao và Nén',
      desc: ' • Hỗ trợ video độ phân giải cao và duy trì hiệu quả lưu trữ thông qua các thuật toán nén.\n • Hỗ trợ các chuẩn nén như H.264, H.265 để tối ưu hóa băng thông và việc sử dụng bộ nhớ.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kết nối Mạng',
      desc: ' • Cho phép truy cập video trực tiếp hoặc đã ghi từ nhiều vị trí khác nhau thông qua mạng.\n • Có khả năng quản lý và giám sát từ xa, hỗ trợ nhiều người dùng để cộng tác hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý Thông báo và Sự kiện',
      desc: ' • Có thể phát hiện và quản lý các sự kiện như phát hiện chuyển động, mất video, che phủ camera, tạm dừng, v.v.\n • Cho phép thiết lập thông báo và cảnh báo để phản ứng nhanh chóng với các sự kiện quan trọng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tìm kiếm và Phát lại Video',
      desc: ' • Có thể tìm kiếm và phát lại video dựa trên khoảng thời gian hoặc sự kiện cụ thể.\n • Cho phép chia nhỏ video, phóng to/thu nhỏ, và điều chỉnh chính xác từng khung hình.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý Lưu trữ',
      desc: ' • Quản lý bộ nhớ hiệu quả và cung cấp nhiều tùy chọn lưu trữ khác nhau.\n • Có thể tự động xóa các video cũ hoặc chuyển sang thiết bị lưu trữ khác theo lịch trình.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Các tính năng Bảo mật đa dạng',
      desc: ' • Có thể thiết lập các mức độ quyền truy cập khác nhau thông qua quản lý quyền người dùng.\n • Hỗ trợ công nghệ mã hóa để truy cập từ xa an toàn.',
      dot: '',
    },
    {
      head: 'Ưu điểm của NVR',
      subHead: 'Độ phân giải cao và Chất lượng hình ảnh',
      desc: 'NVR chủ yếu được sử dụng với camera kỹ thuật số, hỗ trợ video độ phân giải cao và chất lượng hình ảnh vượt trội. Điều này giúp hiển thị rõ ràng các chi tiết và cho phép giám sát chính xác hơn khi cần thiết.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kiến trúc dựa trên Mạng',
      desc: 'NVR giao tiếp với camera thông qua mạng, do đó video có thể được truy cập dễ dàng từ các khu vực từ xa. Điều này cung cấp một phương pháp tiện lợi để giám sát trực tiếp và tìm kiếm video.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tính linh hoạt và Khả năng mở rộng',
      desc: 'Hệ thống NVR hỗ trợ nhiều camera và có thể dễ dàng mở rộng khi cần thiết. Việc thêm camera mới hoặc nâng cấp hệ thống rất đơn giản, giúp phản ứng linh hoạt với sự thay đổi trong yêu cầu bảo mật.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát từ xa và Tính năng Thông báo',
      desc: 'NVR hỗ trợ giám sát video từ xa và thông qua các tính năng nâng cao như phát hiện chuyển động hoặc thông báo qua email, bạn có thể nhận được cảnh báo ngay lập tức khi một sự kiện được phát hiện. Điều này giúp phản ứng nhanh chóng và quản lý hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tính năng Tìm kiếm và Phân tích Video',
      desc: 'Một số hệ thống NVR cung cấp tính năng tìm kiếm và phân tích video, cho phép phát hiện các sự kiện cụ thể và nhanh chóng tìm thấy thông tin cần thiết. Điều này hỗ trợ việc sử dụng hiệu quả dữ liệu điều tra hoặc giám sát.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Lưu trữ và Quản lý Hiệu quả',
      desc: 'NVR cung cấp các chức năng lưu trữ và quản lý video hiệu quả. Nó sử dụng dung lượng lưu trữ một cách hiệu quả và lưu giữ bản ghi video ổn định trong khoảng thời gian cần thiết.',
      dot: '',
    },
    {
      head: 'Sự khác biệt giữa NVR và DVR',
      subHead: 'Kết nối Camera và Xử lý Tín hiệu',
      desc: ' • DVR: DVR chủ yếu được sử dụng với camera analog, xử lý tín hiệu analog bằng cách chuyển đổi chúng thành kỹ thuật số.\n • NVR: NVR được sử dụng với camera kỹ thuật số hoặc camera IP, xử lý dữ liệu đã được truyền ở dạng kỹ thuật số.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Chất lượng Video và Tính năng',
      desc: ' • DVR: Thường cung cấp chất lượng video thấp hơn và có thể bị hạn chế về các tính năng nâng cao.\n • NVR: Cung cấp độ phân giải cao và các tính năng nâng cao, hỗ trợ chất lượng video được cải thiện và nhiều chức năng đa dạng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hỗ trợ Camera và Độ phân giải',
      desc: ' • DVR: Chủ yếu hỗ trợ camera analog độ phân giải thấp và có thể không phù hợp cho video độ phân giải cao.\n • NVR: Hỗ trợ camera kỹ thuật số, tương thích vượt trội với camera độ phân giải cao và Megapixel.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kết nối Mạng',
      desc: ' • DVR: Chủ yếu được kết nối với mạng cục bộ để sử dụng và quyền truy cập từ xa có thể bị hạn chế hơn.\n • NVR: Truyền và nhận dữ liệu qua mạng, do đó có thể dễ dàng truy cập từ các khu vực từ xa.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Khả năng Mở rộng',
      desc: ' • DVR: Thường chỉ hỗ trợ một số lượng camera nhất định và việc mở rộng hệ thống có thể khó khăn hơn.\n • NVR: Hỗ trợ nhiều camera và có thể dễ dàng mở rộng hệ thống khi cần.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Lắp đặt và Bảo trì',
      desc: ' • DVR: Hệ thống analog có thể đơn giản trong lắp đặt và bảo trì, nhưng hiệu suất tổng thể của hệ thống có thể thấp.\n • NVR: Hệ thống kỹ thuật số có thể phức tạp hơn, nhưng cung cấp các tính năng và hiệu suất cao cấp, đồng thời thuận tiện trong bảo trì.',
      dot: '',
    },
  ],

  link: {
    page: 'camera',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
    ],
  },
};
